<template>
  <div class="main">
    <banner-swiper class="other">
      <swiper-slide>
        <div class="banner-cover" />
        <div class="banner-desc other">
          <div class="icon" />
          <div class="title">上海茵谷科技有限公司</div>
          <div class="text">年轻与老练并存 活力与沉稳并济</div>
        </div>
      </swiper-slide>
      <div slot="after" class="english-run">EONGOO</div>
    </banner-swiper>
    <div class="amap wrap" v-if="false">
      <div v-scroll-toggle="['enter']">
        <div ref="mapContainer" class="box"></div>
        <div class="back" @click="back" />
        <div class="desc">
          <div>
            <div class="label">地址：</div>
            <div class="value">上海市金山区亭卫公路1500号（山阳经济小区）</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerSwiper from '@/components/bannerSwiper'

import scrollToggle from '@/directives/scrollToggle'

const position = [121.625439, 29.895705]

export default {
  name: 'About',
  components: {
    BannerSwiper
  },
  directives: {
    scrollToggle
  },
  data() {
    return {
      map: null
    }
  },
  mounted() {
    // 地图暂时隐藏，不加载SDK
    // this.initMap()
  },
  methods: {
    initMap() {
      if (window.AMap) {
        this.createMap()
        return
      }
      // 定义全局回调
      window.initAMapCallback = () => {
        this.createMap()
      }
      const script = document.createElement('script')
      script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=2bbbfd2a980504e30a9ca91e092c007d&callback=initAMapCallback'
      document.head.appendChild(script)
    },
    createMap() {
      this.map = new window.AMap.Map(this.$refs.mapContainer, {
        zoom: 18,
        center: position,
        resizeEnable: true,
        animateEnable: false,
        jogEnable: false
      })
      this.map.setMapStyle('amap://styles/d1f0adf496e38322d6ed32bd23c2c810')

      // 添加标记
      const marker = new window.AMap.Marker({
        position: position,
        content: '<div class="mark"></div>',
        offset: new window.AMap.Pixel(-7, -7)
      })
      this.map.add(marker)

      // 监听resize
      window.AMap.event.addListener(this.map, 'resize', () => {
        this.resize(this.map.getSize())
      })

      // 初始调整位置
      this.$nextTick(() => {
        this.resize(this.map.getSize())
      })
    },
    back() {
      if (this.map) {
        this.resize(this.map.getSize())
      }
    },
    resize(data) {
      if (!this.map || !data) return
      const positionCurrent = this.map.lngLatToContainer(position)
      let positionAims = null
      if (data.width < 850) {
        positionAims = {
          x: data.width / 2,
          y: data.height / 3
        }
      } else {
        positionAims = {
          x: data.width / 4 * 3,
          y: data.height / 2
        }
      }
      this.map.panBy(positionAims.x - positionCurrent.x, positionAims.y - positionCurrent.y)
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-container{
  .banner-cover{
    background-image: url('../../assets/banner_about.jpg');
  }
}
.amap{
  padding: 80px 0;
  >div{
    position: relative;
    display: flex;
    height: 630px;
    align-items: center;
    visibility: hidden;
    &.enter{
      visibility: visible;
      animation: fadeIn 1s backwards;
    }
  }
  .box{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    background-color: $themeBarColor;
  }
  .back{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    width: 26px;
    height: 26px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid #7b1b15;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:before{
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #7b1b15;
      content: '';
    }
  }
  .desc{
    position: relative;
    z-index: 1;
    display: flex;
    width: 350px;
    margin-left: 85px;
    box-sizing: border-box;
    padding: 50px 30px;
    background-color: #7b1b15;
    line-height: 1.5em;
    font-size: 16px;
    color: $themeColorActive;
    >div{
      display: flex;
    }
    .label{
      flex-shrink: 0;
      flex-grow: 0;
    }
    .value{
      flex-shrink: 1;
      flex-grow: 1;
      text-align: justify;
    }
  }
  @media screen and (max-width: 850px) {
    >div{
      justify-content: center;
      align-items: flex-end;
    }
    .desc{
      margin-left: 0;
      margin-bottom: 30px;
    }
  }
  @media screen and (max-width: 800px) {
    >div{
      width: 80%;
      height: 400px;
      margin: 0 auto;
    }
    .desc{
      width: auto;
      margin-left: 10px;
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 15px 20px;
    }
  }
}
</style>

<style lang="scss">
// 地图标记样式 - 需要非scoped才能作用于动态插入的marker
.amap-marker-content .mark{
  position: relative;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #ff0000;
  &:before, &:after{
    position: absolute;
    top: -100%;
    left: -100%;
    right: -100%;
    bottom: -100%;
    box-sizing: border-box;
    border-radius: 50%;
    animation: amapMarkAnim 1s ease-out infinite;
    content: '';
  }
  &:before{
    background-color: rgba(#ff0000, .6);
  }
  &:after{
    border: 1px solid #ff0000;
  }
  @keyframes amapMarkAnim{
    from{
      transform: scale(.3);
      opacity: 1;
    }
    to{
      transform: scale(1);
      opacity: 0;
    }
  }
}
</style>
